export function splitContactTime(value) {
  const parts = String(value || '').split(' ')
  return { nextFollowUpDate: parts[0] || '', nextFollowUpTime: (parts[1] || '').slice(0, 5) }
}

export function joinContactTime(form) {
  const date = form.nextFollowUpDate || ''
  const time = form.nextFollowUpTime || ''
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return null
  return `${date} ${time}:00`
}

export function contactTimePayload(form) {
  const { nextFollowUpDate, nextFollowUpTime, ...payload } = form
  payload.nextFollowUpAt = form.result && form.result !== 'FOLLOW_UP' ? null : joinContactTime(form)
  return payload
}
